function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 111,
  y1: 42,
  x2: 111,
  y2: 60,
  stroke: "var(--secondary)",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 129,
  width: 21,
  height: 7,
  fill: "var(--primary)"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 41,
  y1: 90,
  x2: 41,
  y2: 1,
  stroke: "var(--secondary)",
  strokeWidth: 10
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 44.7979,
  y1: 9.04619,
  x2: 100.947,
  y2: 39.2385,
  stroke: "var(--secondary)",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 33,
  y: 90,
  width: 22,
  height: 7,
  fill: "var(--secondary)"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 129,
  x2: 8,
  y2: 40,
  stroke: "var(--primary)",
  strokeWidth: 10
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 80,
  y1: 80,
  x2: 13,
  y2: 80,
  stroke: "var(--primary)",
  strokeWidth: 10
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 11.6105,
  y1: 47.6904,
  x2: 67.929,
  y2: 77.2288,
  stroke: "var(--primary)",
  strokeWidth: 4
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9 41C18.2288 38.7616 37.7492 27.6277 42 1",
  stroke: "var(--primary)",
  strokeWidth: 2
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  x1: 113,
  y1: 42,
  x2: 46,
  y2: 42,
  stroke: "var(--secondary)",
  strokeWidth: 10
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  x1: 78,
  y1: 81,
  x2: 78,
  y2: 100,
  stroke: "var(--primary)",
  strokeWidth: 4
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M79 79C88.2288 76.7616 107.749 65.6277 112 39",
  stroke: "var(--primary)",
  strokeWidth: 2
});

var SvgOhl = function SvgOhl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 136,
    viewBox: "0 0 113 136",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOhl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ohl.6dbb621d.svg";
export { ForwardRef as ReactComponent };